var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-content',{on:{"click":_vm.handleGoToURL}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.colData.title))]),_c('v-list-item-subtitle',{staticClass:"hyperlink-object"},[_vm._v(_vm._s(_vm.getHyperLinkContent().linkText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }